module.exports = __webpack_public_path__ + "static/media/world_flag.5bcf8e75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/world_flag.svg
// module id = 1278
// module chunks = 103